import * as React from 'react';
import { List } from '~/Partials/List/List';
import styles from './AdditionalNotes.module.css';

export interface AdditionalNotesProps {
    notes?: string[];
}

export const AdditionalNotes: React.FC<React.PropsWithChildren<AdditionalNotesProps>> = ({ notes }) => {
    const filteredNotes = notes?.filter(value => !!value);

    return (
        <>
            {filteredNotes && filteredNotes.length > 0 && (
                <List
                    items={filteredNotes}
                    renderItem={(item, index) => (
                        <li className={styles.ListItem} key={index}>
                            {item}
                        </li>
                    )}
                    className={styles.AdditionalNotes}
                />
            )}
        </>
    );
};
